import React from "react"
import "./LoadingCard.css"

interface LoadingCardProps {
  backgroundColor?: string
  gradient?: string
}

const LoadingCard: React.FC<LoadingCardProps> = ({
  backgroundColor = "#ffffff",
  gradient = "linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%)"
}) => {
  return (
    <div
      className="LoadingCardContainer"
      style={{ backgroundColor }}
    >
      <div className="LoadingCardGradient LoadingCardElement1" style={{ backgroundImage: gradient }} />
      <div className="LoadingCardGradient LoadingCardElement2" style={{ backgroundImage: gradient }} />
      <div className="LoadingCardGradient LoadingCardElement3" style={{ backgroundImage: gradient }} />
      <div className="LoadingCardGradient LoadingCardElement4" style={{ backgroundImage: gradient }} />
      <div className="LoadingCardGradient LoadingCardElement5" style={{ backgroundImage: gradient }} />
    </div>
  )
}

export default LoadingCard
